import * as React from "react";
import { Hint } from "react-ui";

import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";

import * as styles from "./HeaderPanel.styles";
import { Content, Root } from "./HeaderPanel.styles";
import { RoundedBackButton } from "./RoundedBackButton/RoundedBackButton";

export interface HeaderPanelProps {
    onBackButtonClick: () => void;
    backButtonHint?: string;
    children: React.ReactNode[];
}

export function HeaderPanel(props: HeaderPanelProps): JSX.Element {
    const testPageObject = React.useMemo(
        () => ({
            getType: () => "HeaderPanel",
            click: () => props.onBackButtonClick(),
        }),
        []
    );

    return (
        <TestPageObjectHandle id={"HeaderPanel"} pageObject={testPageObject}>
            <Root>
                <Content>
                    <div css={styles.backButton}>
                        <Hint text={props.backButtonHint}>
                            <RoundedBackButton onClick={props.onBackButtonClick} />
                        </Hint>
                    </div>
                    <div css={styles.childrenContainer}>
                        <span>{props.children}</span>
                    </div>
                    <div css={styles.actionsContainer} />
                </Content>
            </Root>
        </TestPageObjectHandle>
    );
}
